import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/arqueos';

import Arqueo from './Arqueo';
import {resetStore} from "../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.arqueo,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(Arqueo);
